module.exports = __webpack_public_path__ + "img/logo.09d8f04c.svg";